module.exports = __webpack_public_path__ + "img/minus.aefc1db3.svg";